<div class="server-error">
    <div class="server-error-text">
        <div class="server-error-message">
            <app-locale localeKey="ERROR_MESSAGE" localeView="DEFAULT_ERROR"></app-locale>
        </div>
        <br>
        <div class="server-error-title">
            <app-locale localeKey="ERROR_TITLE" localeView="DEFAULT_ERROR"></app-locale>
        </div>
        <br>
        <div>
            <app-locale localeKey="ERROR_BODY" localeView="DEFAULT_ERROR"></app-locale>
        </div>
        <br>
        <button type="button" class="btn server-error-back-btn" mat-button (click)="goBackToStart()">
            <app-locale localeKey='RETURN_BTN' localeView='DEFAULT_ERROR'></app-locale>
        </button>
    </div>
</div>